import { createRef, Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import withStyles from 'beam/dist/styles/index'
import { withTranslation } from 'react-i18next'
import { AutoSizer } from 'react-virtualized'
import { SCROLL_ALIGNMENT_FRACTION } from '../MediaPlayer/helpers'

const styles = theme => ({
  root: {
    overflow: 'hidden',
  },
  rootStartInMiddle: {
    backgroundColor: theme.palette.grey[200],
  },
  tape: {
    position: 'relative',
    transition: 'top 0.2s ease-out',
  },
  tapeStartInMiddle: {
    backgroundColor: theme.palette.common.white,
  },
  label: {
    transition: 'top 0.2s ease-out',
    position: 'relative',
  },
  barRoot: {
    position: 'relative',
    height: '100%',
    flex: '0 1 auto',
    display: 'flex',
  },
  contentContainer: {
    width: '100%',
  },
})

class FixedPlayerPiano extends Component {
  static propTypes = {
    classes: PropTypes.object,
    currentTime: PropTypes.number.isRequired, // Current time (where the play head is)
    height: PropTypes.number.isRequired, // Height of the component
    duration: PropTypes.number.isRequired, // Total duration of the player piano
    children: PropTypes.node.isRequired, // Contents of the player piano
  }

  constructor(props) {
    super(props)
    this.tapeRef = createRef()
  }

  // Right away call the tape scroll handler
  componentDidMount() {
    this.scrollTape()
  }

  // If the time, height or contents change we call the tape scroll handler
  componentDidUpdate(prevProps) {
    if (
      this.props.currentTime !== prevProps.currentTime ||
      this.props.height !== prevProps.height ||
      this.props.children !== prevProps.children
    ) {
      this.scrollTape()
    }
  }

  scrollTape() {
    const { currentTime, duration, height } = this.props

    // If we have tape
    if (this.tapeRef.current) {
      const currentRef = this.tapeRef.current
      const tapeHeight = this.tapeRef.current.clientHeight

      // The tape is offset by the percentage of the way through the tape we are times the height of the tape
      const pxOffset = (currentTime / duration) * tapeHeight
      // If we don't start in the middle the seekbar should be halfway down the player piano unless we are near the start or the end of the player piano in which case it should be at 1/x of the way down the player piano
      const noScrollBuffer = height / SCROLL_ALIGNMENT_FRACTION

      let offsetTop = 0

      // The offset of the tape should be the pxOffset which is the percentage of the way we are through the tape subtract the scroll buffer which is where the seekbar should be (ex. 1/x of the way down the  player piano)
      offsetTop = pxOffset - noScrollBuffer

      // The position of the tape should be set based on the offset
      const topStyle = -1 * Math.floor(offsetTop)
      currentRef.style.top = `${topStyle}px`
    }
  }

  render() {
    const { children, height, classes } = this.props

    return (
      <div
        className={classNames(classes.root, classes.rootStartInMiddle)}
        style={{ height: `${height}px` }}
      >
        <div ref={this.tapeRef} className={classNames(classes.tape, classes.tapeStartInMiddle)}>
          <div className={classes.barRoot}>
            <div className={classes.contentContainer}>{children}</div>
          </div>
        </div>
      </div>
    )
  }
}

// Just like FixedPlayerPiano except in a height-only AutoSizer component
const PlayerPiano = props => (
  <AutoSizer disableWidth>{({ height }) => <FixedPlayerPiano {...props} height={height} />}</AutoSizer>
)

export { PlayerPiano as UnstyledPlayerPiano }
export default withTranslation()(withStyles(styles)(PlayerPiano))
